import { render } from "./detalhesCarga.vue?vue&type=template&id=2e39160c&scoped=true"
import script from "./detalhesCarga.vue?vue&type=script&lang=js"
export * from "./detalhesCarga.vue?vue&type=script&lang=js"

import "./detalhesCarga.vue?vue&type=style&index=0&id=2e39160c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e39160c"]])

export default __exports__